'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, TextPassage } from '@petsmart-ui/sparky';
import { useFormContext, useWatch } from 'react-hook-form';
import type { Product } from '@libs/common-types';
import { AutoshipPurchaseOptions } from '../product-details';
import { MiniPdpAutoshipFrequency } from './mini-pdp-autoship-frequency';
import { useMiniPdpAutoship } from './model/use-mini-pdp-autoship';
import type { MiniPdpForm } from './types';
type MiniPdpAutoshipOptionsProps = Readonly<{
  product: Product;
  onOpenAutoshipInfo: () => void;
}>;
export function MiniPdpAutoshipOptions(t0) {
  const $ = _c(14);
  const {
    product,
    onOpenAutoshipInfo
  } = t0;
  const {
    register
  } = useFormContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "purchaseOption"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const purchaseOption = useWatch(t1);
  const {
    shouldRender,
    isLoading,
    isDisabled,
    messages
  } = useMiniPdpAutoship(product);
  if (!shouldRender) {
    return null;
  }
  let t2;
  if ($[1] !== register) {
    t2 = register("purchaseOption");
    $[1] = register;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onOpenAutoshipInfo) {
    t3 = <Button iconName="info-outline" iconSize="sm" onClick={onOpenAutoshipInfo} title="Autoship Information" variant="bare" data-testid="mini-pdp-autoship-info-button" type="button" />;
    $[3] = onOpenAutoshipInfo;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MiniPdpAutoshipFrequency />;
    t5 = <TextPassage className="purchase-options__autoship-text" size="sm">Choose how you want to receive your first order below.</TextPassage>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isDisabled || $[8] !== isLoading || $[9] !== messages || $[10] !== purchaseOption || $[11] !== t2 || $[12] !== t3) {
    t6 = <AutoshipPurchaseOptions selected={purchaseOption} inputProps={t2} isAutoshipDisabled={isDisabled} isLoading={isLoading} messages={messages} infoSlot={t3} testId="mini-pdp-purchase-options">{t4}{t5}</AutoshipPurchaseOptions>;
    $[7] = isDisabled;
    $[8] = isLoading;
    $[9] = messages;
    $[10] = purchaseOption;
    $[11] = t2;
    $[12] = t3;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}